import * as Yup from "yup";

export const settingsSchema = Yup.object().shape({
  value: Yup.string().required("This field is required"),
  key: Yup.string().required("This field is required"),
  description: Yup.string(),
});
